export const MIN_ZOOM = 0.1;
export const MAX_ZOOM = 1;
export const ACTION_ICON_PADDING = 6;
export const DEPENDENTS_SEARCH_THRESHOLD = 5;
export const TOOLTIP_OPEN_DELAY = 700;
